import { styled } from "styled-components";

export const AppContainer = styled.div`
  background-color: rgba(244, 245, 249, 1);
`
